import { request } from "../axios/request";

export const getAntennasService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/antennas", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getSingleAntennasService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/antennas/" + id, getState(), {
        method: "GET",
      })
    );
  };
};

export const getAllAntennasService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/antennas", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveAntennaService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/antennas/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/antennas", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteAntennaService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/antennas/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
